export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EventsDirectory.vue?vue&type=template&id=72deec50"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/EventsDirectory.vue?vue&type=template&id=72deec50
// module id = 296
// module chunks = 0